import Vue from 'vue';
import _ from 'lodash';
import authErrorHandler from '@/service/handler/auth-error';

const API_URL = process.env.VUE_APP_API_URL;

import { Order, OrderDetails, IOrderProductsMap, ChangeStatusResult } from './types';

const convertResponseOrders = (raw: any) => {
  return _.toArray(_.map(raw, (item) => {
    return new Order(item);
  }));
}

const convertResponseOrderDetails = (raw: any) => {
  return new OrderDetails(raw);
}

const decodeMap = (raw: any): IOrderProductsMap => {
  let genMap: IOrderProductsMap = {};
  _.each(raw, (order) => {
    let idOrder: string = _.toString(_.get(order, 0));
    let encodedQuantities: string = _.get(order, 1);
    genMap[idOrder] = encodedQuantities;
  });
  return genMap;
}

export default {
  async getAll(): Promise<any> {
    return Vue.$axios
      .post(`${API_URL}/orders`, {
        "where": {},
        // "items": 5,
        // "page": 2,
        "orderBy": {
          "dateAdd": "DESC"
        }
      })
      .then((resp) => {
        return convertResponseOrders(_.get(resp, 'data.data.orders', []));
      })
      .catch(reason => {
        if (_.isString(reason)) {
          authErrorHandler();
        }
      });
  },
  async getMap(): Promise<any> {
    return Vue.$axios
      .get(`${API_URL}/orders/products`)
      .then((resp) => {
        return decodeMap(_.get(resp, 'data.data', []));
      })
      .catch(reason => {
        if (_.isString(reason)) {
          authErrorHandler();
        }
        return false;
      });
  },
  async getOne(id: number): Promise<OrderDetails> {
    return Vue.$axios
      .get(`${API_URL}/order/${id}`)
      .then((resp) => {
        return convertResponseOrderDetails(_.get(resp, 'data.data.Order', {}));
      })
      .catch(reason => {
        if (_.isString(reason)) {
          authErrorHandler();
        }
        return reason;
      });
  },
  async reject(id: number): Promise<ChangeStatusResult> {
    return Vue.$axios
      .get(`${API_URL}/order/rejected/${id}`)
      .then((resp) => {
        if (resp.status == 422) {
          return ChangeStatusResult.NotExists;
        } else if (_.get(resp.data, 'success', false)) {
          return ChangeStatusResult.Ok;
        }
        return ChangeStatusResult.Error;
      })
      .catch(reason => {
        const status = _.get(reason, 'response.status');
        const message = _.get(reason, 'response.data.message');
        if (_.isString(reason)) {
          authErrorHandler();
        } else if (status === 404) {
          return ChangeStatusResult.NotExists;
        } else if (message === 'error: id order not found') {
          return ChangeStatusResult.NotExists;
        }
        return ChangeStatusResult.ConnectionLost;
      });
  },
  async confirm(id: number): Promise<ChangeStatusResult> {
    return Vue.$axios
      .get(`${API_URL}/order/approved/${id}`)
      .then((resp) => {
        if (resp.status == 422) {
          return ChangeStatusResult.NotExists;
        } else if (_.get(resp.data, 'success', false)) {
          return ChangeStatusResult.Ok;
        }
        return ChangeStatusResult.Error;
      })
      .catch(reason => {
        const status = _.get(reason, 'response.status');
        const message = _.get(reason, 'response.data.message');
        if (_.isString(reason)) {
          authErrorHandler();
        } else if (status === 404) {
          return ChangeStatusResult.NotExists;
        } else if (message === 'error: id order not found') {
          return ChangeStatusResult.NotExists;
        }
        return ChangeStatusResult.ConnectionLost;
      });
  }
};